export function pluralizeHours(length: number) {
  return `${length} Hour${length > 1 || length < -1 ? 's' : ''}`;
}
